import * as moment from 'moment';
import { Entity, Type } from '@decahedron/entity';
import Picture from '@/entities/Picture';
import CarOption from '@/entities/CarOption';
import Formatter from '@/support/formatter';

export default class Car extends Entity {
  protected formatter = new Formatter();

  public id: string = null;

  public title: string = null;

  public firstRegistration: string = null;

  public body: string = null;

  public mileage: number = null;

  public activeTill: string = null;

  public fuel: string = null;

  public transmission: string = null;

  public price: number = null;

  public vatDeductible = false;

  @Type(Picture) pictures: Picture[] = [];

  @Type(CarOption) public options: CarOption[] = [];

  public isSold = false;

  public isReserved = false;

  public fuelTypeId: string = null;

  public transmissionTypeId: string = null;

  public position: number = null;

  get priceString(): string {
    return `€ ${this.formatter.formatNumber(this.price)}`;
  }

  get mileageString(): string {
    return `${this.formatter.formatNumber(this.mileage)}`;
  }

  hasOption(option: CarOption): boolean {
    return this.options.some((currentOption) => currentOption.id === option.id);
  }

  toggleOption(option: CarOption) {
    for (let n = 0; n < this.options.length; n += 1) {
      if (this.options[n].id === option.id) {
        return this.options.splice(n, 1);
      }
    }

    return this.options.push(option);
  }

  removePicture(picture: Picture) {
    for (let n = 0; n < this.pictures.length; n += 1) {
      if (this.pictures[n].url === picture.url) {
        this.pictures.splice(n, 1);
        break;
      }
    }
  }

  addPicture(picture: Picture) {
    if (!picture.position) {
      picture.position = this.pictures.length + 1; // eslint-disable-line
    }

    this.pictures.push(picture);
  }

  fromJson(jsonData: any): Car {
    super.fromJson(jsonData);

    if (this.activeTill) {
      this.activeTill = moment.default(this.activeTill).utc().format('YYYY-MM-DD HH:mm:ss');
    }

    return this;
  }
}
